import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from 'theme';

export const StyledWrapper = styled.div`
  max-width: ${container('lg')};
  width: 100%;
  margin: ${spacing('xl')} auto ${spacing('xl5')};
  background-color: ${color('white')};
  padding: 0 ${spacing('xl2')} ${spacing('xl2')};
  border-radius: ${radius('md')};
  display: flex;
  flex-direction: column;
`;

export const StyledTitle = styled.h3`
  display: inline-flex;
  font-size: ${fontSize('md')};
  font-weight: ${fontWeight('extraBold')};
  text-transform: uppercase;
  letter-spacing: 0.35em;
  padding: ${spacing('md')};
  color: ${color('text_subtle')};
  background-color: ${color('midnight_100')};
  margin: 0 auto;
`;

export const StyledTabs = styled.div`
  display: flex;
  gap: ${spacing('md')};
  margin-bottom: ${spacing('lg')};
  margin-top: ${spacing('lg')};
`;

export const StyledTab = styled.button`
  padding: ${spacing('sm')} ${spacing('xs')};
  background: unset;
  border: 0;
  border-bottom: ${spacing('xs2')} solid transparent;
  font-family: ${fontFamily('display')};
  font-weight: ${fontWeight('semiBold')};
  font-size: ${fontSize('xl2')};
  text-transform: uppercase;
  line-height: 1;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  padding: ${spacing('sm')};
  color: ${color('link')};
  transition: 0.2s;
  cursor: pointer;

  &.is-active {
    color: ${color('text_default')};
    border-color: ${color('active')};
  }

  &[disabled] {
    color: ${color('text_disabled')};
    pointer-events: none;
  }
`;

export const StyledSectionTitle = styled.h4`
  margin-top: 0;
  margin-bottom: ${spacing('lg')};
  padding-top: ${spacing('md')};
  padding-bottom: ${spacing('md')};
  display: flex;
  align-items: center;
  gap: ${spacing('md')};
  font-size: ${fontSize('lg')};
  line-height: 1.2;
  font-weight: ${fontWeight('extraBold')};
  border-bottom: 1px solid ${color('emerald_300')};

  svg {
    width: ${spacing('xl')} !important;
    height: ${spacing('xl')};
    color: ${color('emerald_300')};
  }
`;

export const StyledData = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};
  margin-bottom: ${spacing('xl')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    gap: ${spacing('xl3')};
  }

  > *:first-child {
    flex-shrink: 0;
  }
`;

export const StyledDataMonthList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('md')};
  flex-grow: 1;

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    gap: ${spacing('xl')};
  }
`;

export const StyledDataMonth = styled.div`
  flex-basis: 33.33%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${spacing('xs')} ${spacing('md')};

  @media (min-width: ${screen('md')}) {
    flex-direction: column;
    flex-wrap: unset;
    gap: ${spacing('mdlg')};
  }
`;

export const StyledDataMonthTitle = styled.span`
  color: ${color('text_subtle')};
  text-transform: uppercase;
  font-size: ${fontSize('sm')};
  line-height: 1.142;
  font-weight: ${fontWeight('extraBold')};
  letter-spacing: 0.25em;
  width: 100%;

  @media (min-width: ${screen('md')}) {
    width: auto;
  }
`;

export const StyledTendency = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs2')};
`;

export const StyledTendencyTitle = styled.span`
  color: ${color('text_subtle')};
  font-weight: ${fontWeight('medium')};
`;

export const StyledTendencyValue = styled.div`
  display: flex;
  gap: ${spacing('xs')};
  align-items: center;
  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('black')};
`;

export const StyledTendencyVariation = styled.div`
  display: flex;
  gap: ${spacing('xs2')};
  align-items: center;
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('extraBold')};

  svg {
    width: ${spacing('md')} !important;
    height: ${spacing('md')};
  }
  &.positive svg {
    color: ${color('positive_500')};
  }
  &.negative svg {
    color: ${color('negative_500')};
  }
  &.neutral svg {
    color: ${color('notice_500')};
  }
`;

export const StyledGoalsTitle = styled.h5`
  margin-top: ${spacing('md')};
  margin-bottom: ${spacing('md')};
  color: ${color('text_subtle')};
  font-weight: ${fontWeight('extraBold')};
  text-transform: uppercase;
  padding: ${spacing('sm')};
  background-color: ${color('midnight_100')};
`;

export const StyledGoal = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs')};

  h6 {
    margin: 0;
    font-size: ${fontSize('md')};
    font-weight: ${fontWeight('extraBold')};
    display: flex;
    align-items: flex-start;
    gap: ${spacing('xs')};
  }

  p {
    line-height: 1.5;
    margin-top: 0;
  }
`;

export const StyledGoalIcon = styled.div`
  width: ${spacing('lg')};
  height: ${spacing('lg')};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid;
  border-radius: ${radius('full')};
  flex-shrink: 0;
  margin-top: -2px;

  svg {
    width: ${spacing('md')} !important;
    height: ${spacing('md')};
  }

  &.positive {
    border-color: ${color('positive_500')};
    svg {
      color: ${color('positive_500')};
    }
  }
  &.negative {
    border-color: ${color('negative_500')};
    svg {
      color: ${color('negative_500')};
    }
  }
  &.neutral {
    border-color: ${color('notice_500')};
    svg {
      color: ${color('notice_500')};
    }
  }
`;
